import ForgotPasswordSuccessBlock from './ForgotPasswordSuccessBlock';
import { ForgotPasswordSuccessBlockProps, ForgotPasswordSuccessBlockValueProps } from './types';

export type { ForgotPasswordSuccessBlockProps, ForgotPasswordSuccessBlockValueProps };
export default ForgotPasswordSuccessBlock;
